module.exports = __webpack_public_path__ + "static/media/DefaultImage.0868abc2.png";